module.exports = __webpack_public_path__ + "media/images/marketing-li-5ab800836b4e8fcf1217fdf04812803d.png";